import {Component, OnDestroy, OnInit} from '@angular/core';
import {Project} from "@catcore/types/api-v2";
import {isNullOrUndefined} from "util";
import {ProjectService} from "@catcore/services";
import {Subscription} from "rxjs";
import {ProjectUnit} from "@catmodels/project-units/types";

interface TableItem {
  name: string;
  label: string;
  featureLabel: string;
  guiZoneLabel: string;
  service: string;
  modelName: string;
}

@Component({
  selector: 'cat-evid-functions',
  templateUrl: './evid-functions.component.html',
  styleUrls: ['./evid-functions.component.scss']
})
export class EvidFunctionsComponent implements OnInit, OnDestroy {

  datatableSource: TableItem[] = [];
  private evidFunctions;
  subscription: Subscription = null;

  private project: Project;

  constructor(private projectService: ProjectService) { }

  ngOnInit() {
    this.subscription = this.projectService
      .getCurrentProject()
      .subscribe((currentProject: Project) => {
        const isActiveProject = !isNullOrUndefined(currentProject) && !isNullOrUndefined(currentProject.id);
        if (isActiveProject) {

          this.project = currentProject;

          const subscr = this.projectService.getAllEvidFunctions(this.project)
            .finally(() => subscr.unsubscribe())
            .subscribe((evidFunctions) => {
              this.evidFunctions = evidFunctions;
              this.updateTableData(evidFunctions);
            });

        } else {
          this.project = null;
        }
      });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  private updateTableData(evidFunctions) {
    this.datatableSource = [];
    evidFunctions.forEach((evidFunction) => {
      const item = {
        featureLabel: evidFunction._links.feature.label,
        guiZoneLabel: evidFunction._links.gui_zone.label,
        name: evidFunction.name,
        label: evidFunction.label,
        modelName: evidFunction.model_name,
        service: evidFunction._links.hasOwnProperty('service') ? evidFunction._links.service.label : '',
      };
      this.datatableSource = [...this.datatableSource, item];
    });
  }

}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/models/evid-functions/components/evid-functions/evid-functions.component.ts